// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1M0pK","empty":"ModalGraph_empty__16KTk"};